import React from 'react';
import './styles/tailwind.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LookupPage from './pages/LookupPage';
function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/lookup" element={<LookupPage />} />
                <Route path="*" element={<HomePage />} />
            </Routes>
        </Router>
    );
}


export default App;
